/**
 * type-program.js — Single product detail layout for in-person Programs.
 *
 * Renders the full detail view (date, location, speakers, CPD points, pricing,
 * Add-to-Cart, related programs) for face-to-face and live-stream programs.
 *
 * Props: inherited from SIngleProduct.js.
 */

// ─── External libraries ───────────────────────────────────────────────────────
import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  ClockIcon,
  CalendarIcon,
  FaceBookIcon,
  TwitterIcon,
  LinkedFIcon,
  MessageIcon,
  LikeIcon,
  ShareIcon,
} from "../../../icons";
import {
  Container,
  Row,
  Col,
  ListGroup,
  Form,
  Modal,
  Accordion,
} from "react-bootstrap";
import PrintingImg from "../../../images/printing.png";
import user_default_image from "../../../images/user.png";
import pm from "../../../images/pm-new.svg";
import ps from "../../../images/ps-new.svg";
import sl from "../../../images/sl-new.svg";
import ep from "../../../images/ep-new.svg";
import StreamIcon from "../../../images/stream.svg";
import TimerIcon from "../../../images/timer.svg";
import LocationIcon from "../../../images/location.svg";
import { PresentorModal } from "../../Modals/Presentor";
import { RelatedProgram } from "./../relatedProgram/RelatedProgram";
import QuantitySelect from "../../common/QuantitySelect";

import Bg from "../../../images/tile-new.png";

// import Swiper core and required modules
import SwiperCore, { Navigation, Pagination } from "swiper";
// install Swiper modules
SwiperCore.use([Navigation, Pagination]);
const TypeProgram = (props) => {

  // new api datas

  let title =
    props.single_program_basic_data.title !== undefined
      ? props.single_program_basic_data.title
      : "";
  let handlee = props.handle !== undefined ? props.handle : "";
  let description =
    props.single_program_basic_data.description !== undefined
      ? props.single_program_basic_data.description
      : "";
  let date_line1 =
    props.single_program_data.Program_Date_Time_Line_1__c !== "" && props.single_program_data.Program_Date_Time_Line_1__c !== null
      ? props.single_program_data.Program_Date_Time_Line_1__c
      : "";
  let date_line2 =
    props.single_program_data.Program_Date_Time_Line_2__c !== "" && props.single_program_data.Program_Date_Time_Line_2__c !== null
      ? props.single_program_data.Program_Date_Time_Line_2__c
      : "";
  let Designed_For__c =
    props.single_program_data.Designed_For__c !== "" && props.single_program_data.Designed_For__c !== null
      ? props.single_program_data.Designed_For__c
      : "";
  let Catering =
    props.single_program_data.Catering__c !== "" && props.single_program_data.Catering__c !== null
      ? props.single_program_data.Catering__c
      : "";
  let Venue__c =
    props.single_program_data.Venue__c !== "" &&
    props.single_program_data.Venue__c !== null
      ? props.single_program_data.Venue__c
      : "";
  let Venue_link =
    Venue__c !== "" && Venue__c !== "Live Stream Only"
      ? "https://www.google.com/maps/search/?api=1&query=" + Venue__c
      : "#";
    
  let Ethics =
    props.single_program_data.Ethics_Professional_Responsibility__c > 0
      ? props.single_program_data.Ethics_Professional_Responsibility__c
      : 0;
  let practice_managment =
    props.single_program_data.Practice_Management_Business_Skills__c > 0
      ? props.single_program_data.Practice_Management_Business_Skills__c
      : 0;
  let professional_skills =
    props.single_program_data.Professional_Skills__c > 0
      ? props.single_program_data.Professional_Skills__c
      : 0;
  let Substantive_Law =
    props.single_program_data.Substantive_Law__c > 0
      ? props.single_program_data.Substantive_Law__c
      : 0;
  let total_points =
    parseFloat(Ethics) +
    parseFloat(practice_managment) +
    parseFloat(professional_skills) +
    parseFloat(Substantive_Law);
  let Short_Promotion_Message__c =
    props.single_program_data.Short_Promotion_Message__c !== "" && props.single_program_data.Short_Promotion_Message__c !== null
      ? props.single_program_data.Short_Promotion_Message__c
      : "";
  let Long_Promotion_Message__c =
    props.single_program_data.Long_Promotion_Message__c !== "" && props.single_program_data.Long_Promotion_Message__c !== null
      ? props.single_program_data.Long_Promotion_Message__c
      : "";
  let delivery_mode =
    props.single_program_data.delivery_mode !== "" && props.single_program_data.delivery_mode !== null
      ? props.single_program_data.delivery_mode
      : [];
  let product_code =
    props.single_program_basic_data.product_code !== undefined && props.single_program_basic_data.product_code !== null &&
    props.single_program_basic_data.product_code !== ""
      ? props.single_program_basic_data.product_code
      : "";
  let product_price =
    props.single_program_basic_data.price !== undefined &&
    props.single_program_basic_data.price !== "" && props.single_program_basic_data.price !== null
      ? props.single_program_basic_data.price
      : 0;
  let related_program =
    props.single_program_data.related_program.length > 0
      ? props.single_program_data.related_program
      : [];
  let presentor =
    props.single_program_data.presentor.length > 0
      ? props.single_program_data.presentor
      : [];
  let session_topics =
    props.single_program_data.topic !== undefined &&
    props.single_program_data.topic !== null
      ? props.single_program_data.topic
      : [];
  let TEN_MINITES = props.is_ten_minite_less(
    props.single_program_data.start_date_time
  )
    ? true
    : false;
  let isPorgramOver = props.program_date_is_gone_or_not(
    props.single_program_data.start_date_time
  )
    ? true
    : false;
  let start_date_time =
    props.single_program_data.start_date_time !== "" && props.single_program_data.start_date_time !== null
      ? props.single_program_data.start_date_time
      : "";
  const Program_Structure__c =
    props.single_program_data.Program_Structure__c !== "" &&
    props.single_program_data.Program_Structure__c !== null &&
    props.single_program_data.Program_Structure__c !== undefined
      ? props.single_program_data.Program_Structure__c
      : null;
  const Program_Structure__c_Array =
    Program_Structure__c !== null ? Program_Structure__c.split(" ") : [];
  const Early_Bird_Price__c =
    props.single_program_data.Compare_Price !== "" &&
    props.single_program_data.Compare_Price !== null
      ? props.single_program_data.Compare_Price
      : undefined;
  const [DefaultRadioValue, setDefaultRadioValue] = useState(
    delivery_mode === undefined || delivery_mode.length === 0
      ? ""
      : delivery_mode[0]
  );

  const [DefaultRadio, setDefaultRadio] = useState(0);

  const UpdateRadio = (value, index) => {
    setDefaultRadioValue(value);
    setDefaultRadio(index);
  };
  session_topics.sort(function (a, b) {
    return parseInt(a.Session_No__c) - parseInt(b.Session_No__c);
  });  

  // new api datas end

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const { RevetCopyText } = props;

  useEffect(() => {
    if (!show) {
      RevetCopyText();
    }
  }, [show, RevetCopyText]);
  const handleShow = () => setShow(true);
  let top_author_index = 0;

  const randm = () => {
    return (Math.random() + 1).toString(36).substring(7);
  };

  const [showPresentorModal, setShowPresentorModal] = useState(false);
  const [presentor_modal_data, set_presentor_modal_data] = useState({
    name: "",
    image: "",
    job: "",
    description: "",
    linkedin: "",
    author_company_title: "",
  });
  
  const hide_presentor_modal = () => {
    setShowPresentorModal(false);
  };

  const price_float = parseFloat(product_price);

  let Session_need_to_show = false;
  session_topics.forEach((topic, index) => {

    // console.log('topic', topic);
    const topic_desc =
      topic.Blurb__c !== null && topic.Blurb__c !== "" ? topic.Blurb__c : "";
    const topic_allocated_time =
      topic.Allocated_Time_Minutes__c !== undefined &&
      topic.Allocated_Time_Minutes__c !== null &&
      topic.Allocated_Time_Minutes__c > 0
        ? topic.Allocated_Time_Minutes__c
        : 0;
    if (
      topic_desc !== null &&
      topic_desc !== "" &&
      topic_allocated_time > 0 &&
      index !== 0
    ) {
      Session_need_to_show = true;
    }
  });

  const numberWithCommas = (x) => {
    return parseFloat(x)
      .toFixed(2)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  //console.log("isPorgramOver ->"+isPorgramOver);
  return (
    <div className={"single_program_page mprogram " + props.product_page_type}>
      <Container>
        <div className="single_program_wrapper position-relative">
          <Row>
            <Col xl={8} lg={7} xs={12}>
              <div className="cpd_single_programs_content">
                <div className="single_programs_head">
                  <h1 className="mb-0">
                    {title}{" "}
                    <small className="product_code d-md-none">
                      {product_code}
                    </small>
                  </h1>
                </div>
                <div className="cpd_summary_block">
                  {Program_Structure__c !== null && Program_Structure__c !== undefined ? (
                    <h3 className="cpd_summary_title">{Program_Structure__c}</h3>
                  ) : null}
                  <ul className="cpd_summary_badges list-unstyled">
                    {Program_Structure__c !== "Medicare Billing Course" && total_points > 0 ? (
                      <li className="cpd_summary_badge">
                        <span className="cpd_summary_icons">
                          {professional_skills > 0 ? (
                            <img src={ps} alt="Professional Skills" title="Professional Skills" />
                          ) : null}
                          {practice_managment > 0 ? (
                            <img src={pm} alt="Practice Management & Business Skills" title="Practice Management & Business Skills" />
                          ) : null}
                          {Substantive_Law > 0 ? (
                            <img src={sl} alt="Substantive Law" title="Substantive Law" />
                          ) : null}
                          {Ethics > 0 ? (
                            <img src={ep} alt="Ethics & Professional Responsibility" title="Ethics & Professional Responsibility" />
                          ) : null}
                        </span>
                        <span>CPD {total_points} point{total_points > 1 ? "s" : ""}</span>
                      </li>
                    ) : null}
                    {delivery_mode.length ? (
                      <li className="cpd_summary_badge">
                        <img
                          className="cpd_summary_badge_icon"
                          src={delivery_mode.some((m) => typeof m === "string" && /face to face|on[\s-]?site/i.test(m)) ? LocationIcon : StreamIcon}
                          alt=""
                        />
                        <span>{delivery_mode.join(", ")}</span>
                      </li>
                    ) : null}
                    {Program_Structure__c !== "Medicare Billing Course" && total_points > 0 ? (
                      <li className="cpd_summary_badge">
                        <img className="cpd_summary_badge_icon" src={TimerIcon} alt="" />
                        <span>{total_points} hour{total_points > 1 ? "s" : ""}</span>
                      </li>
                    ) : null}
                  </ul>
                </div>

                <div className="single_rightside">
                  <div className="single_rightside_inner">
                    <div className="program_right_cart">
                      {Early_Bird_Price__c !== undefined ? (
                        <div className="early_bird_banner d-none d-md-block">EARLY BIRD PRICE</div>
                      ) : null}
                      <div className="program_right_cart_head d-flex flex-column flex-sm-row justify-content-between">
                        <h2 className="text-primary d-none d-md-block">
                          {title}{" "}
                          <small className="product_code">{product_code}</small>
                        </h2>
                        <div className="program_price d-none d-md-inline-block fsadfsfd">
                          {Early_Bird_Price__c !== undefined ? (
                            <span className="discount_price">
                              ${numberWithCommas(Early_Bird_Price__c)}
                            </span>
                          ) : null}
                          ${numberWithCommas(price_float)}
                        </div>
                      </div>

                      <div className="wishlist_and_short_sms d-flex flex-wrap align-items-center">
                        <button
                          className={
                            props.getAllWishlist.includes(handlee)
                              ? "wishlist_link wishlist_link_add"
                              : "wishlist_link"
                          }
                          onClick={() =>
                            props.AddtoWishlist(handlee, start_date_time)
                          }
                        >
                          {" "}
                          {props.getAllWishlist.includes(handlee) ? (
                            <>
                              Added to bookmarks <LikeIcon />
                            </>
                          ) : (
                            <>
                              Add to bookmarks <LikeIcon />
                            </>
                          )}
                        </button>

                        {!props.reached_capacity ? (
                          Short_Promotion_Message__c !== "" &&
                          Short_Promotion_Message__c !== null ? (
                            <ListGroup
                              horizontal
                              as="ul"
                              className="short_promotion_message"
                            >
                              <ListGroup.Item as="li">
                                <div className="label_tag p-0">
                                  {Short_Promotion_Message__c}
                                </div>
                              </ListGroup.Item>
                            </ListGroup>
                          ) : null
                        ) : (
                          ""
                        )}
                      </div>

                      <div className="length_block list_block">
                        {date_line1 !== "" && date_line1 !== null ? (
                          <>
                            {date_line1 !== "" ? (
                              <small className="d-flex">
                                <CalendarIcon /> <span>{date_line1}</span>
                              </small>
                            ) : null}
                          </>
                        ) : null}
                        {date_line2 !== "" && date_line2 !== null ? (
                          <>
                            {date_line2 !== "" ? (
                              <small className="d-flex">
                                <ClockIcon /> {date_line2}
                              </small>
                            ) : null}
                          </>
                        ) : null}
                        <button
                          className="print_info"
                          onClick={() => window.print()}
                        >
                          Print course information
                          <img src={PrintingImg} alt="Print" className="print-icon-img" />
                        </button>
                        {Long_Promotion_Message__c !== "" &&
                        Long_Promotion_Message__c !== null ? (
                          <p className="price_sale d-flex">
                            <ClockIcon stroke="#fe1010" />{" "}
                            {Long_Promotion_Message__c}
                          </p>
                        ) : null}
                      </div>
                      {Venue__c !== "" && Venue__c !== null ? (
                        <div className="designed_block list_block">
                          <p>Venue</p>
                          <small><a href={Venue_link} rel="noreferrer" target="_blank">{Venue__c}</a></small>
                        </div>
                      ) : null}
                      {Designed_For__c !== "" && Designed_For__c !== null ? (
                        <div className="designed_block list_block">
                          <p>Designed for</p>
                          <small>{Designed_For__c}</small>
                        </div>
                      ) : null}
                      {Catering !== "" &&
                      Catering !== null &&
                      delivery_mode !== null &&
                      delivery_mode !== undefined &&
                      delivery_mode.includes("Face to Face") ? (
                        <div className="catering_block list_block">
                          <p>Catering</p>
                          <small>{Catering}</small>
                        </div>
                      ) : null}

                      <div className="quantity_block list_block">
                        {Early_Bird_Price__c !== undefined ? (
                          <div className="early_bird_banner d-md-none">EARLY BIRD PRICE</div>
                        ) : null}
                        <div className="program_right_cart_head mb-3">
                          <div className="program_price d-md-none">
                            <span className="discount_price">
                              {Early_Bird_Price__c !== undefined
                                ? "$" + numberWithCommas(Early_Bird_Price__c)
                                : null}
                            </span>
                            ${numberWithCommas(price_float)}
                          </div>
                        </div>

                        {!TEN_MINITES ? (
                          isPorgramOver ? null : !props.reached_capacity &&
                            delivery_mode.length ? (
                            <div className="form_check_group d-flex align-items-center">
                              <span>Please select: </span>
                              {delivery_mode !== undefined &&
                              delivery_mode.length > 0
                                ? delivery_mode.map((cpd, index) => {
                                    return (
                                      <Form.Check
                                        inline
                                        key={`inline5-${randm()}`}
                                        name={props.handle}
                                        label={cpd}
                                        value={cpd}
                                        checked={
                                          parseInt(index) ===
                                          parseInt(DefaultRadio)
                                        }
                                        onChange={(e) =>
                                          UpdateRadio(e.target.value, index)
                                        }
                                        type="radio"
                                        id={`inline-${randm()}-1`}
                                      />
                                    );
                                  })
                                : ""}
                            </div>
                          ) : null
                        ) : null}
                        <div className="d-flex align-items-center justify-content-between qty-cart-group">
                          {!TEN_MINITES ? (
                            isPorgramOver ? null : !props.reached_capacity ? (
                              <Form.Group
                                className="mb-0"
                                controlId="formBasicEmail"
                              >
                                <div className="quantity_group position-relative">
                                  <Form.Label className="text-primary">
                                    Qty
                                  </Form.Label>
                                  <QuantitySelect
                                    value={props.quantity}
                                    onChange={(n) => props.increaseQuantity(n)}
                                  />
                                </div>
                              </Form.Group>
                            ) : null
                          ) : null}
                          {!TEN_MINITES ? (
                            isPorgramOver ? (
                              <div className="label_tag">Bookings Closed</div>
                            ) : !props.reached_capacity ? (
                              <button
                                data-tet={props.SingleVariants.id}
                                onClick={(e) =>
                                  props.AddtoCart(
                                    props.SingleVariants.id,
                                    props.quantity > 0 ? props.quantity : 1,
                                    props.SingleVariants.sku,
                                    DefaultRadioValue,
                                    props.recordType,
                                    props.tags,
                                    props.Program_structure_image,
                                    handlee,
                                    props.single_program_data.start_date_time,
                                    Program_Structure__c
                                  )
                                }
                                className="btn btn-secondary mt-0 btn_cart"
                              >
                                Add to Cart
                              </button>
                            ) : (
                              <strong>Fully Booked</strong>
                            )
                          ) : (
                            <div className="label_tag">Bookings Closed</div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <button
                    className="share_colleagues_link d-flex align-items-center"
                    onClick={handleShow}
                  >
                    Share with colleagues
                    <ShareIcon />
                  </button>
                </div>

                <Accordion defaultActiveKey="0">
                  {description !== "" && description !== null ? (
                    <Accordion.Item
                      eventKey="0"
                      className="description-accordion"
                    >
                      <Accordion.Header>Description</Accordion.Header>
                      <Accordion.Body>
                        <div className="programs_description">
                          <div
                            dangerouslySetInnerHTML={{ __html: description }}
                          />
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  ) : null}
                  {
                    // PROGRAM SESSIONS
                    Session_need_to_show ? (
                      <Accordion.Item
                        eventKey="1"
                        className="sessions-accordion"
                      >
                        <Accordion.Header>Sessions</Accordion.Header>
                        <Accordion.Body>
                          {session_topics.map((topic) => {
                            // console.log('topic', topic);
                            const topic_name =
                              topic.Session__c !== null &&
                              topic.Session__c !== ""
                                ? topic.Session__c
                                : "";
                            const topic_desc =
                              topic.Blurb__c !== null && topic.Blurb__c !== ""
                                ? topic.Blurb__c
                                : "";
                            const topic_CPD_category =
                              topic.CPD_Category__c !== null
                                ? topic.CPD_Category__c.split(";")
                                : [];
                            const topic_allocated_time =
                              topic.Allocated_Time_Minutes__c !== undefined &&
                              topic.Allocated_Time_Minutes__c !== null &&
                              topic.Allocated_Time_Minutes__c > 0
                                ? topic.Allocated_Time_Minutes__c
                                : 0;
                            
                            if (
                              topic_name !== null &&
                              topic_name !== "" &&
                              topic_desc !== null &&
                              topic_desc !== "" &&
                              topic_allocated_time > 0
                            ) {
                              return (
                                <div className="" key={topic_name}>
                                  <div className="session_topic_block">
                                    <h5 className="display-5">{topic_name}</h5>
                                    <div className="session_icons_row">
                                    {topic_CPD_category.map((cpd) => {
                                      var cpd_image = undefined;
                                      if (
                                        cpd ===
                                        "Practice Management & Business Skills"
                                      ) {
                                        cpd_image = pm;
                                      }
                                      if (cpd === "Professional Skills") {
                                        cpd_image = ps;
                                      }
                                      if (cpd === "Substantive Law") {
                                        cpd_image = sl;
                                      }
                                      if (
                                        cpd ===
                                        "Ethics & Professional Responsibility"
                                      ) {
                                        cpd_image = ep;
                                      }
                                      return (
                                        <img
                                          src={cpd_image}
                                          alt={cpd}
                                          key={cpd}
                                        />
                                      );
                                    })}
                                    </div>
                                  </div>
                                  {topic.Contact_info != null &&
                                  topic.Contact_info.length > 0 ? (
                                    <div className="author_group" key="1222">
                                      <Row xs={1} xl={2}>
                                        {topic.Contact_info.map(
                                          (topic_author) => {
                                            let topic_author_job_title =
                                              topic_author.Job_Title_Position__c !==
                                                undefined &&
                                              topic_author.Job_Title_Position__c !==
                                                null &&
                                              topic_author.Job_Title_Position__c !==
                                                ""
                                                ? topic_author.Job_Title_Position__c
                                                : "";
                                            let topic_author_account_name =
                                              topic_author.Account_Name !==
                                                undefined &&
                                              topic_author.Account_Name !==
                                                null &&
                                              topic_author.Account_Name !== ""
                                                ? topic_author.Account_Name
                                                : "";
                                            let topic_author_top_job_account =
                                              [];
                                            if (
                                              topic_author_job_title !== ""
                                            ) {
                                              topic_author_top_job_account = [
                                                ...topic_author_top_job_account,
                                                topic_author_job_title,
                                              ];
                                            }
                                            if (
                                              topic_author_account_name !== ""
                                            ) {
                                              topic_author_top_job_account = [
                                                ...topic_author_top_job_account,
                                                topic_author_account_name,
                                              ];
                                            }

                                            return (
                                              <Col key={topic_author.Name}>
                                                <div className="author_card">
                                                  <div className="author_card_head">
                                                    <img
                                                      src={
                                                        topic_author.Presenter_Profile_Photo_URL__c !==
                                                        null
                                                          ? topic_author.Presenter_Profile_Photo_URL__c
                                                          : user_default_image
                                                      }
                                                      alt={topic_author.Name}
                                                    />
                                                    <p>{topic_author.Name}</p>
                                                    <small>
                                                      {topic_author_top_job_account.join(
                                                        ", "
                                                      )}
                                                    </small>
                                                  </div>
                                                </div>
                                              </Col>
                                            );
                                          }
                                        )}
                                      </Row>
                                    </div>
                                  ) : null}

                                  <div className="programs_description">
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: topic_desc,
                                      }}
                                    ></div>
                                  </div>
                                </div>
                              );
                            }else{
                              return null;
                            }
                            
                          })}
                        </Accordion.Body>
                      </Accordion.Item>
                    ) : null
                  }
                  {presentor.length ? (
                    <Accordion.Item
                      eventKey="2"
                      className="presenters-accordion"
                    >
                      <Accordion.Header>Presenters</Accordion.Header>
                      <Accordion.Body>
                        <div className="author_group">
                          <Row xs={1} xl={2}>
                            {presentor.map((top_author) => {
                              top_author_index = top_author_index + 1;
                              let author_name =
                                top_author.Contact_info !== undefined &&
                                top_author.Contact_info[0] !== undefined
                                  ? top_author.Contact_info[0].Name
                                  : null;
                              let author_image =
                                top_author.Contact_info !== undefined &&
                                top_author.Contact_info[0] !== undefined
                                  ? top_author.Contact_info[0]
                                      .Presenter_Profile_Photo_URL__c
                                  : null;
                              
                              let author_job_title =
                                top_author.Contact_info !== undefined &&
                                top_author.Contact_info[0] !== undefined &&
                                top_author.Contact_info[0][
                                  "Job_Title_Position__c"
                                ] !== null
                                  ? top_author.Contact_info[0][
                                      "Job_Title_Position__c"
                                    ]
                                  : "";
                              let author_account_name =
                                top_author.Contact_info !== undefined &&
                                top_author.Contact_info[0] !== undefined &&
                                top_author.Contact_info[0]["Account_Name"] !==
                                  null
                                  ? top_author.Contact_info[0]["Account_Name"]
                                  : "";
                              let author_description =
                                top_author.Contact_info !== undefined &&
                                top_author.Contact_info[0] !== undefined &&
                                top_author.Contact_info[0][
                                  "Presenter_Instructor_Profile__c"
                                ] !== null
                                  ? top_author.Contact_info[0][
                                      "Presenter_Instructor_Profile__c"
                                    ]
                                  : "";
                              let author_linkedin =
                                top_author.Contact_info !== undefined &&
                                top_author.Contact_info[0] !== undefined
                                  ? top_author.Contact_info[0].LinkedIn_URL__c
                                  : null;
                              let author_top_job_account = [];
                              if (author_job_title !== "") {
                                author_top_job_account = [
                                  ...author_top_job_account,
                                  author_job_title,
                                ];
                              }
                              if (author_account_name !== "") {
                                author_top_job_account = [
                                  ...author_top_job_account,
                                  author_account_name,
                                ];
                              }
                              return (
                                <Col key={top_author_index}>
                                  <div className="author_card">
                                    <div className="author_card_head">
                                      <img
                                        src={
                                          author_image === undefined ||
                                          author_image === null
                                            ? user_default_image
                                            : author_image
                                        }
                                        alt={author_image}
                                      />
                                      <p>{author_name}</p>
                                      <small>
                                        {author_top_job_account.join(", ")}
                                      </small>
                                    </div>
                                    <div className="author_card_content quote_description">
                                      {author_description.length >= 200 ? (
                                        <>
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html:
                                                author_description.substring(
                                                  0,
                                                  200
                                                ),
                                            }}
                                          />
                                          <button
                                            className="btn-leo-link p-0"
                                            onClick={() => {
                                              let popup_author_image =
                                                author_image === undefined ||
                                                author_image === null ||
                                                author_image === ""
                                                  ? user_default_image
                                                  : author_image;
                                              setShowPresentorModal(true);
                                              set_presentor_modal_data({
                                                name: author_name,
                                                image: popup_author_image,
                                                job: author_top_job_account.join(
                                                  ", "
                                                ),
                                                description: author_description,
                                                linkedin: author_linkedin,
                                                author_company_title: "",
                                              });
                                            }}
                                          >
                                            Read More
                                          </button>
                                        </>
                                      ) : null}
                                    </div>
                                  </div>
                                </Col>
                              );
                            })}
                          </Row>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  ) : null}
                </Accordion>
              </div>
            </Col>
            <Col xl={4} lg={5} xs={12}></Col>
          </Row>
        </div>
      </Container>
      {related_program !== undefined && related_program.length > 0 ? (
        <div
          className="related_courses_wrapper"
          style={{ backgroundImage: "url(" + Bg + ")" }}
        >
          <Container>
            <h2 className="text-center">Related Programs</h2>
            <Swiper
              cssMode={true}
              spaceBetween={24}
              slidesPerView={4}
              navigation={false}
              pagination={{
                clickable: true,
              }}
              breakpoints={{
                0: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 2,
                },
                1200: {
                  slidesPerView: 4,
                },
              }}
              modules={[Pagination]}
            >
              {related_program.map((related_program) => {                               
                if (related_program.Related_Program__c !== "" && related_program.Related_Program__c !== null) {
                  return (
                    <SwiperSlide key={Math.random()}>
                      <RelatedProgram
                        productHandle={related_program.Slug__c}
                        AddtoCart={props.AddtoCart}
                        Program_structure_images={props.Program_structure_image}
                        is_ten_minite_less={props.is_ten_minite_less}
                        program_date_is_gone_or_not={
                          props.program_date_is_gone_or_not
                        }
                      />
                    </SwiperSlide>
                  );
                }else{
                  return null;
                }
              })}
            </Swiper>
          </Container>
        </div>
      ) : null}

      <>
        <Modal show={show} onHide={handleClose} className="share_modal">
          <Modal.Header closeButton className="border-0"></Modal.Header>
          <Modal.Body>
            <Modal.Title>
              Share This Program
            </Modal.Title>
            <ListGroup
              horizontal
              as="ul"
              className="social_media_list"
            >
              <ListGroup.Item
                as="li"
                className="social_item"
                onClick={() => props.FBshare()}
              >
                <FaceBookIcon fill="#004e6d" />
              </ListGroup.Item>
              <ListGroup.Item
                as="li"
                className="social_item"
                onClick={() => props.TwitterShare()}
              >
                <TwitterIcon fill="#004e6d" />
              </ListGroup.Item>
              <ListGroup.Item
                as="li"
                className="social_item"
                onClick={() => props.LinkedinShare()}
              >
                <LinkedFIcon fill="#004e6d" />
              </ListGroup.Item>
              <ListGroup.Item
                as="li"
                className="social_item"
                onClick={() => props.emailShare()}
              >
                <MessageIcon fill="#004e6d" />
              </ListGroup.Item>
            </ListGroup>
            <button
              onClick={() => props.CopyLink()}
              className="btn btn-primary"
            >
              {props.Clipboard}
            </button>
          </Modal.Body>
        </Modal>
      </>
      <PresentorModal
        presentor_modal_data={presentor_modal_data}
        show={showPresentorModal}
        hide={hide_presentor_modal}
      />
    </div>
  );
};

export default TypeProgram;
